import { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";

import { useUserEmailVerify } from "@providers/index";
import { useNotify } from "@hooks/index";

export const VerifyEmailPage = () => {
  const location = useLocation();
  const idValue = location.pathname.split("/").slice(-2)[0];
  const hashValue = location.pathname.split("/").slice(-1)[0];
  const queryValue = location.search;

  const notify = useNotify();

  const { mutate, isIdle, isPending, isSuccess } = useUserEmailVerify(
    () => notify("success", "Your Email is verified successfully!"),
    ({ message }) => notify("error", message),
  );

  useEffect(() => {
    mutate({
      id: idValue,
      hash: hashValue,
      query: queryValue,
    });
  }, [mutate, idValue, hashValue, queryValue]);

  if (isIdle || isPending) {
    return <div className="text-lg">Redirecting...</div>;
  } else if (isSuccess) {
    return <Navigate to="/" />;
  } else {
    return null;
  }
};
